// Makes the entire collection card clickable, not just the title link.
// Uses a single delegated listener so it works regardless of CSS stacking
// or third-party elements layered over the card. Real links/buttons inside
// the card keep their normal behaviour.
(function () {
  if (window.__collectionCardLinkInit) return;
  window.__collectionCardLinkInit = true;

  document.addEventListener('click', function (e) {
    var wrapper = e.target.closest('.collection-card-wrapper');
    if (!wrapper) return;

    // Don't hijack clicks on genuine interactive elements (the title link,
    // pagination, wishlist buttons an app may add, etc.).
    if (e.target.closest('a[href], button, [role="button"], input, select, label')) return;

    var link = wrapper.querySelector('.card__full-link, .card__heading a[href], a[href]');
    if (link && link.href) {
      window.location.href = link.href;
    }
  });
})();
